import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

// Статический импорт нужных локалей
import { enUS, ru, uk, th, zhCN } from 'date-fns/locale';

const localeMap: any = {
  en: enUS,
  'en-US': enUS,
  ru
};

export const useGetLocale = () => {
  const { i18n } = useTranslation();

  const locale = useMemo(() => {
    const lang = i18n.language;
    const shortLang = lang.split('-')[0];

    return localeMap[lang] || localeMap[shortLang] || enUS;
  }, [i18n.language]);

  return locale;
};
